import { unified } from 'unified';
import remarkParse from 'remark-parse';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import remarkRehype from 'remark-rehype';
import rehypeStringify from 'rehype-stringify';

/**
 * Zet bestaande markdown of platte tekst om naar HTML, zodat de editor er iets
 * mee kan. Alleen nodig voor velden die geschreven zijn vóór de editor bestond.
 *
 * Zelfde plugins als de renderer (RichText), dus wat de lezer nu ziet is wat de
 * editor toont. Zonder remark-breaks zou platte tekst met enters tot één alinea
 * samenklappen — precies de tekst van bestaande agenda-items en nieuwsberichten.
 *
 * `allowDangerousHtml` staat bewust uit: HTML in de invoer wordt wéggegooid,
 * niet doorgegeven en ook niet ge-escaped. Daarom mag deze functie alleen op
 * velden die echt markdown/platte tekst bevatten — voor een veld dat HTML kan
 * bevatten gebruik je de `html`-vlag op RichText/RichTextEditor.
 */
const processor = unified()
  .use(remarkParse)
  .use(remarkGfm)
  .use(remarkBreaks)
  .use(remarkRehype)
  .use(rehypeStringify);

export function markdownToHtml(markdown: string): string {
  return String(processor.processSync(markdown));
}
